import {Button, Tooltip, Typography} from "@mui/material";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const WarningComponent = ({title}) => {
    return <Tooltip
        title={<Typography variant="body1"><div style={{fontSize: '16px'}} dangerouslySetInnerHTML={{__html: title}}/></Typography>}
        enterTouchDelay={0}
        leaveTouchDelay={500000}
        classes={{ tooltip: 'maxWidth500' }}>
        <Button className="pb-0">
            <FontAwesomeIcon icon={['fas', 'exclamation-triangle']}  size={"4x"} className="text-danger" />
        </Button>
    </Tooltip>
}

export default WarningComponent;